import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonIcon } from '@subaio/webapp'

import { helpers } from 'styles'

export const ButtonDelete = styled(ButtonIcon)`
	color: ${helpers.color.danger};
	background-color: ${({ theme }) => transparentize(0.94, theme.color.danger)};

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => transparentize(0.9, theme.color.danger)};
	}
`
